import { getHawaiiShippingAddress } from "../features/checkout/checkoutSlice"

export const CUSTOMER_ACCESS_TOKEN_KEY = "c_at"
export const LAST_CHECKOUT_ID_KEY = "c_lc"
export const LAST_CART_ID_KEY = "c_lcart"

export const DELIVERY_OPTIONS = {
  LOCAL_PICKUP: "pickup",
  LOCAL_DELIVERY: "oahu",
  NEIGHBOR_ISLAND_SHIPPING: "neighbor",
  US_MAINLAND_SHIPPING: "mainland",
}

export const SPECIAL_EVENTS = {
  ASRC_WAKE_ISLAND: "asrc-wake-island",
  HANALE_ISLAND_SAKE: "hanale-island-sake",
  INSPIRE_YACHT: "inspire-yacht",
}

export const SPECIAL_EVENTS_DATA = {
  [SPECIAL_EVENTS.ASRC_WAKE_ISLAND]: {
    displayAddress: "99-1405 Koaha Place, Unit D, Aiea, HI 96701",
    shippingAddress: getHawaiiShippingAddress({
      address1: "99-1405 Koaha Place",
      address2: "Unit D",
      city: "Aiea",
      zip: "96701",
    }),
  },
  [SPECIAL_EVENTS.HANALE_ISLAND_SAKE]: {
    displayAddress: "25 N. King St. Honolulu, HI 96817",
    shippingAddress: getHawaiiShippingAddress({
      address1: "25 N. King St.",
      address2: "",
      city: "Honolulu",
      zip: "96817",
    }),
    schedule: JSON.parse(import.meta.env.VITE_HANALE_SCHEDULE),
  },
  [SPECIAL_EVENTS.INSPIRE_YACHT]: {
    displayAddress: "1125 Ala Moana Blvd, Honolulu, HI 96814",
    shippingAddress: getHawaiiShippingAddress({
      address1: "1125 Ala Moana Blvd",
      address2: "",
      city: "Honolulu",
      zip: "96814",
    }),
    schedule: JSON.parse(import.meta.env.VITE_INSPIRE_YACHT_SCHEDULE),
  },
}

export const DEFAULT_PRODUCT_IMAGE =
  "https://cdn.shopify.com/s/images/themes/product-1.png"
